var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('h1',{staticClass:"headline mb-1"},[_vm._v("Detalle del documento")]),_c('DocumentosFirmadosSimple',{attrs:{"paqueteId":_vm.$route.params.id}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }